import React from 'react';
import { Typography, Button } from '@mui/material';
import { toast } from 'react-toastify';
import { sendGeneralEmail } from '../../api/tenantApi';




const OtherServices = ({
  isExpanded,
  user,
  tenantId,
  currentCounter,
  maxCounterLimit
}) => {
  const handleEnableModule = async () => {
    try {
      const message = `
        User Info for Tenant ${user?.name}:
        
        Tenant Name: ${user?.name}
        Tenant Id: ${tenantId}
        Tenant Email: ${user?.email}
        Tenant Phone No: ${user?.user_metadata?.phone_number}
        
        User Request to enable AR
      `;
      await sendGeneralEmail({
        tenantId,
        subject: "User Request to enable AR",
        message,
        to:['michal@crediarc.com', 'nimrod.lanir@crediarc.com']
      });
      console.log("Email sent successfully");

      toast.success("We have received your request. A CrediArc representative will contact you!");
    } catch (error) {
      toast.error("Failed to send request");
    }
  };

    const handleBuyMoreCompanies = async () => {
    try {
      const message = `
        User Info for Tenant ${user?.name}:
        
        Tenant Name: ${user?.name}
        Tenant Id: ${tenantId}
        Tenant Email: ${user?.email}
        Tenant Phone No: ${user?.user_metadata?.phone_number}
        
        Current Limit For Companies: ${maxCounterLimit}
        Number Of Companies Used: ${maxCounterLimit - currentCounter}/${maxCounterLimit}
        Remaining Balance: ${currentCounter}
      `;

      await sendGeneralEmail({
        tenantId,
        subject: "Request to increase Company Limit",
        message,
        to:['michal@crediarc.com', 'nimrod.lanir@crediarc.com']
      });
      console.log("Email sent successfully");

      toast.success("We have received your request. A CrediArc representative will contact you!");
    } catch (error) {
      toast.error("Failed to send request");
    }
  };

  if (!isExpanded) return null;

  return (
    <div style={{
      background: '#FAFAFC',
      padding: '20px',
      borderRadius: '0 0 8px 8px',
      boxShadow: '0px 4px 6px -1px rgba(0, 0, 0, 0.1), 0px 2px 4px -1px rgba(0, 0, 0, 0.06), 0px 1px 3px rgba(0, 0, 0, 0.08)',
    }}>
      <div style={{ maxWidth: '600px' }}>
        <Typography variant="h6" gutterBottom>
          We have some more stuff for you!
        </Typography>
        
        <Typography color="textSecondary" paragraph>
          Based on your contract, you can add up to {currentCounter} additional companies.
          <br />
          Click here to increase the allowed number of companies.
        </Typography>

        <Typography color="textSecondary" sx={{ mt: 2 }}>
          Number of companies used
          <span style={{
            marginLeft: '13px',
            fontWeight: '500',
            fontSize: '17px',
            color: '#2F3D63'
          }}>
            {Math.max((maxCounterLimit ?? 10) - Math.max(currentCounter, 0), 0)}/{maxCounterLimit ?? 10}
          </span>
        </Typography>

        <Button
          variant="contained"
          onClick={handleBuyMoreCompanies}
          sx={{
            mt: 2,
            mb: 4,
            background: '#5186EC',
            '&:hover': {
              background: '#4070d6'
            }
          }}
        >
          Buy More
        </Button>

        <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
          AR
        </Typography>
        
        <Typography color="textSecondary" paragraph>
          Enable Account Receivable and Aging monitoring module
        </Typography>

        <Button
          variant="contained"
          onClick={handleEnableModule}
          sx={{
            mt: 2,
            mb: 4,
            background: '#5186EC',
            '&:hover': {
              background: '#4070d6'
            }
          }}
        >
          Enable AR
        </Button>

        <div style={{ mt: 4 }}>
          <Typography variant="h6" component="span" sx={{ mr: 2 }}>
            Connect Platform to Slack:
          </Typography>
          <a
            href="https://slack.com/oauth/v2/authorize?client_id=5974095873905.8322002014259&scope=channels:join,channels:manage,channels:read,chat:write,incoming-webhook,users:read,users:read.email&user_scope=users:read.email,users:read"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              alt="Connect to Slack"
              height="40"
              width="139"
              src="https://platform.slack-edge.com/img/add_to_slack.png"
              srcSet="https://platform.slack-edge.com/img/add_to_slack.png 1x, https://platform.slack-edge.com/img/add_to_slack@2x.png 2x"
            />
          </a>
        </div>

        <Typography sx={{ mt: 4 }}>
          <a
            href="mailto:support@crediarc.com"
            style={{
              color: '#5186EC',
              textDecoration: 'underline'
            }}
          >
            Contact us for help & more information »
          </a>
        </Typography>
      </div>
    </div>
  );
};

export default OtherServices; 